module.exports = __webpack_public_path__ + "static/media/user_check.7deba3c2.svg";